import { render, staticRenderFns } from "./ElTabPane.vue?vue&type=template&id=82416bd6"
import script from "./ElTabPane.vue?vue&type=script&lang=js"
export * from "./ElTabPane.vue?vue&type=script&lang=js"
import style0 from "./ElTabPane.vue?vue&type=style&index=0&id=82416bd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports